<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | Customers
        div.small.text-muted
          | Displaying customers that have interacted with your bot
      div.col-sm-7.hidden-sm-down
        b-dropdown.float-right(type='button', variant='primary', v-if='userAccessLevel != "agent"')
          template(slot='button-content')
            i.icon-cloud-download
            | &nbsp;&nbsp;Export
          b-dropdown-item(@click='xlsx', type='button', variant='info')
            | Download as xlsx
          b-dropdown-item(@click='pdf', type='button', variant='info')
            | Download as pdf
        b-button.float-right(type='button', variant='primary', @click='pdf', v-else)
          i.icon-cloud-download
          | &nbsp;Export as pdf
    br
    user-table
</template>

<script>
import { ec, ecp } from '@/jsonToXlsx'
export default {
  name: 'dashboard',
  data() {
    return {
      userAccessLevel: this.$store.state.profile.accessLevel,
    }
  },
  mounted: function() {
  },
  methods: {
    xlsx: function() {
      ec()
    },
    pdf: function() {
      ecp()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/Users.vue?d86fffe8